import { put, call } from "redux-saga/effects";
import {
    CREATE_STRIPECUSTOMER_SUCESS, CREATE_STRIPECUSTOMER_FAILED,
    CREATE_SUBCRIPTION_SUCESS,CREATE_SUBCRIPTION_FAILED,
    GETALL_SUBCRIPTION_SUCESS,GETALL_SUBCRIPTION_FAILED,
    
    CREATE_FREQUENCY_SUCESS,CREATE_FREQUENCY_FAILED,
    GETALL_FREQUENCY_SUCESS,GETALL_FREQUENCY_FAILED,
    CREATE_COMPANY_DISCOUNT_SUCESS,CREATE_COMPANY_DISCOUNT_FAILED,
   
    
     
} from "../actions/StripePayment";
import { StripePaymentAPI } from "../../utils/api/StripePaymentsAPI";

export function* createStripeCustomer(request: any) {
 
    try {
        const result = yield call(StripePaymentAPI.createStripeCustomer, request.input);
        yield put({
            type: CREATE_STRIPECUSTOMER_SUCESS, 
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: CREATE_STRIPECUSTOMER_FAILED, payload: e.message });
    }
}

export function* createFrequency(request: any) {
 
    try {
           const result=yield call(StripePaymentAPI.createFrequency, request.input);
         yield put({ 
            type: CREATE_FREQUENCY_SUCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: CREATE_FREQUENCY_FAILED, payload: e.message });
    }
}
export function*getAllFrequencyDetails (request:any) {
    try {
      
        const { data } = yield call(StripePaymentAPI.getAllFrequencyDetails,request);
   
      
      yield put({
          type: GETALL_FREQUENCY_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GETALL_FREQUENCY_FAILED, payload: e.message });
    }
}


export function* saveSubscription(request: any) {
 
    try {
           const result=yield call(StripePaymentAPI.saveSubscription, request.input);
         yield put({ 
            type: CREATE_SUBCRIPTION_SUCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: CREATE_SUBCRIPTION_FAILED, payload: e.message });
    }
}
export function*getSubscriptionList (request:any) {
    try {
      
        const { data } = yield call(StripePaymentAPI.getSubscriptionList,request);
   
      
      yield put({
          type: GETALL_SUBCRIPTION_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GETALL_SUBCRIPTION_FAILED, payload: e.message });
    }
}

export function* createCompanyDiscount(request: any) {
 
    try {
           const result=yield call(StripePaymentAPI.createCompanyDiscount, request.input);
         yield put({ 
            type: CREATE_COMPANY_DISCOUNT_SUCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: CREATE_COMPANY_DISCOUNT_FAILED, payload: e.message });
    }
}